import Skeleton, { SkeletonProps } from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";

export const LoadingSkeleton = (props: SkeletonProps) => (
  <Skeleton baseColor="#FFFFFF1F" highlightColor="#f5f5f5" {...props} />
);
